var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[(_vm.templateType)?_c(_vm.templateType === 1 ? 'DefaultTemplate' : 'RankTemplate',{tag:"component",attrs:{"ranking-details":_vm.rankingDetails}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }